import { useMutation } from "@tanstack/react-query";
import httpRequest from "app/lib/axios/index";
import { APPLICANT } from "app/constants/apiEndPoints";

interface VerifyOtpRequest {
  id: string;
  otp: number;
}

interface VerifyOtpResponse {
  success: boolean;
  message: string;
}

const verifyOtp = async ({
  id,
  otp,
}: VerifyOtpRequest): Promise<VerifyOtpResponse> => {
  const response = await httpRequest.post<VerifyOtpResponse>(
    `${APPLICANT}/${id}/verify-otp`,
    { otp }
  );
  return response.data;
};

export const useVerifyOtp = () => {
  return useMutation<VerifyOtpResponse, Error, VerifyOtpRequest>({
    mutationFn: verifyOtp,
  });
};
